/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

const NoteIconToolbarSlotFill = createSlotFill(
	Symbol( 'NoteIconToolbarSlotFill' )
);

export default NoteIconToolbarSlotFill;
